import { callAPIWhiteToken } from '../config/api';

const PATH_API = process.env.REACT_APP_API;

export async function getPostTestForVideo(learningAssetsVideoUniqueId: string) {
	const url = `${PATH_API}/learning-users-post-test/video/${learningAssetsVideoUniqueId}`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function getPostTestResult(learningAssetsVideoUniqueId: string) {
	const url = `${PATH_API}/learning-users-post-test/result/${learningAssetsVideoUniqueId}`;
	return await callAPIWhiteToken({
		url,
		method: 'GET',
	});
}

export async function submitPostTestAnswers(data: {
	learningAssetsVideoUniqueId: string;
	answers: { questionUniqueId: string; choiceUniqueId: string }[];
}) {
	const url = `${PATH_API}/learning-users-post-test/submit`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		data,
	});
}
